const list = {
  // =================================================================================================================
  components() {
    return [
      {
        'component': 'search-column-keyword',
        label: '검색조건',
        value: 'column',
        query: {'ck_t': 'head', 'ck_k': 'keyword'},
        options: {hiddenList: ['']}
      },
    ]
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    //  검색조건
    const heads = list.getHead().map(e => {return {[e.name] : e.key}});
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({key: types[search.column.head], operator: 'LIKE', value: `%${search.column.keyword}%`})
    }
    return conditions;
  },


  // =================================================================================================================
  getHead: () => {
    return [
      { name: "학교(기관)명", key: "body.stdInfo.field_name"  },
      { name: "실시시기(예정)", key: "body.실시시기" },
      { name: "실시방법", key: "body.실시방법" },
      { name: "업체명", key: "body.업체명" },
      { name: "조리", key: "body.조리" },
      { name: "시설", key: "body.시설" },
      { name: "청소", key: "body.청소" },
      { name: "과학실험실", key: "body.과학실험실" },
      { name: "사무실", key: "body.사무실" },
      { name: "위험성 감소대책 실행 건수", key: "body.실행건수" },
      { name: "근로자 참여", key: "body.근로자참여" },
      { name: "근로자 교육", key: "body.근로자교육" },
    ];
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0: return func.getContent(value).stdInfo.field_name; // 학교(기관)명
        case 1: return func.getContent(value).실시시기;
        case 2: return func.getContent(value).실시방법;
        case 3: return func.getContent(value).업체명;
        case 4: return func.getContent(value).조리;
        case 5: return func.getContent(value).시설;
        case 6: return func.getContent(value).청소;
        case 7: return func.getContent(value).과학실험실;
        case 8: return func.getContent(value).사무실;
        case 9: return func.getContent(value).실행건수;
        case 10: return func.getContent(value).근로자참여;
        case 11: return func.getContent(value).근로자교육;
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
};
export default list;
